import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMoviesList } from '../../api/index';
export default {
  name: 'filmBlacklist',
  props: {
    module: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      filmList: [],
      checkedfilms: [],
      searchBrand: {
        customer_id: '',
        customer_account_id: '',
        movie_name: '',
        page: 1,
        pagesize: 20
      },
      pages: {},
      isShow: false,
      datetime: null,
      totalCount: 0
    };
  },
  methods: {
    add0: function add0(m) {
      return m < 10 ? '0' + m : m;
    },
    timeToStr: function timeToStr(inTime) {
      var time = new Date(inTime);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s);
    },
    changeTime: function changeTime(row, val) {
      var startTime = '';
      var newStartTime = '';
      if (val) {
        startTime = new Date(val[0]).getTime();
        if (startTime < new Date().getTime()) {
          newStartTime = this.timeToStr(new Date().getTime());
        } else {
          newStartTime = val[0];
        }
      } else {
        newStartTime = '';
      }
      var endTime = '';
      var newEndTime = '';
      if (val) {
        endTime = new Date(val[1]).getTime();
        if (endTime < new Date().getTime()) {
          newEndTime = this.timeToStr(new Date().getTime());
        } else {
          newEndTime = val[1];
        }
      } else {
        newEndTime = '';
      }
      var index = this.checkedfilms.findIndex(function (item) {
        return item.id === row.id;
      });
      this.$delete(this.checkedfilms[index], 'start_time');
      this.$delete(this.checkedfilms[index], 'end_time');
      this.$delete(this.checkedfilms[index], 'datetime');
      this.$set(this.checkedfilms[index], 'start_time', newStartTime);
      this.$set(this.checkedfilms[index], 'end_time', newEndTime);
      this.$set(this.checkedfilms[index], 'datetime', val ? [newStartTime, newEndTime] : ['', '']);
    },
    delCheckedFilm: function delCheckedFilm(id) {
      var _this = this;
      this.$confirm('是否将影片从黑名单中删除', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(function () {
        var index = _this.checkedfilms.findIndex(function (item) {
          return item.id === id;
        });
        _this.checkedfilms.splice(index, 1);
      }).catch(function () {});
    },
    handleSelectFilm: function handleSelectFilm(val) {
      this.tempFilms = val;
    },
    getFilmList: function getFilmList() {
      var _this2 = this;
      var params = _objectSpread({}, this.searchBrand);
      getMoviesList(this.module, params).then(function (res) {
        _this2.filmList = res.data.movies.data;
        _this2.checkedfilms = res.data.black_movies;
        _this2.pages = res.data.movies.pages;
        _this2.totalCount = res.data.movies.totalCount;
        _this2.checkedfilms.forEach(function (item) {
          if (item.start_time && item.end_time) {
            item.datetime = [item.start_time, item.end_time];
          } else {
            item.datetime = ['', ''];
          }
        });
      });
    },
    save: function save() {
      var _this3 = this;
      this.checkedfilms.forEach(function (item) {
        item.datetime = item.datetime ? item.datetime : ['', ''];
        item.start_time = item.datetime[0];
        item.end_time = item.datetime[1];
      });
      var params = {
        black_movies: this.checkedfilms,
        customer_id: this.searchBrand.customer_id,
        customer_account_id: this.searchBrand.customer_account_id
      };
      setBlackMovies(params).then(function (res) {
        _this3.$message.success('设置成功');
        _this3.isShow = false;
        _this3.$emit('changeFilms');
      });
    },
    selectable: function selectable(row, index) {
      return row.disabled;
      // var indexs = []
      // this.checkedfilms.forEach(e => {
      // 	const condition = e.id === row.id
      // 	if (condition) {
      // 		indexs.push(index)
      // 	}
      // })
      // if (indexs.indexOf(index) === -1) {
      // 	return true
      // }
    },
    // 批量添加蛋糕
    batchAddFilm: function batchAddFilm() {
      this.checkedfilms = this.checkedfilms.concat(this.tempFilms);
      this.tempFilms = [];
      this.$refs.multipleTable.clearSelection();
    },
    // 清空已选影片
    clearChecked: function clearChecked() {
      var _this4 = this;
      this.$confirm('是否将影片从黑名单中删除', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(function () {
        _this4.checkedfilms = [];
      }).catch(function () {});
    },
    onChange: function onChange(val, flag) {
      this.searchBrand.page = val;
      this.getFilmList();
    },
    sizeChange: function sizeChange(val, status) {
      this.searchBrand.pagesize = val;
      this.getFilmList();
    }
  }
};